<div class="page attendance-dashboard">
  <div class="page-header">
    <div>
      <h1>{{ 'ATTENDANCE_DASH.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'ATTENDANCE_DASH.SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <button type="button" class="btn btn-secondary" (click)="loadReport()" [disabled]="loading || exporting">
        <mat-icon>refresh</mat-icon>
        {{ 'ATTENDANCE_DASH.REFRESH' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="printPdf()"
        [disabled]="loading || exporting || !selectedClassId || (!report?.rows?.length && !rangeReport?.rows?.length)"
        [attr.title]="!selectedClassId ? ('ATTENDANCE_DASH.PDF_SELECT_CLASS' | translate) : null"
      >
        <mat-icon>picture_as_pdf</mat-icon>
        {{ (exporting ? 'ATTENDANCE_DASH.PDF_EXPORTING' : 'ATTENDANCE_DASH.PRINT_PDF') | translate }}
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="printAbsentPdf()"
        [disabled]="loading || exporting || !hasAbsentForPdf"
      >
        <mat-icon>person_off</mat-icon>
        {{ (exporting ? 'ATTENDANCE_DASH.PDF_EXPORTING' : 'ATTENDANCE_DASH.PRINT_ABSENT_PDF') | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="openScanner()" [disabled]="exporting">
        <mat-icon>qr_code_scanner</mat-icon>
        {{ 'ATTENDANCE_DASH.OPEN_SCANNER' | translate }}
      </button>
    </div>
  </div>

  <section class="filters-bar" [attr.aria-label]="'ATTENDANCE_DASH.FILTERS' | translate">
    <div class="filter-group period-group">
      <span class="filter-label">{{ 'ATTENDANCE_DASH.PERIOD' | translate }}</span>
      <div class="period-toggle" role="tablist">
        <button
          type="button"
          class="period-btn"
          role="tab"
          [class.active]="periodMode === 'day'"
          [attr.aria-selected]="periodMode === 'day'"
          (click)="setPeriodMode('day')"
          [disabled]="loading || exporting"
        >
          {{ 'ATTENDANCE_DASH.DAY' | translate }}
        </button>
        <button
          type="button"
          class="period-btn"
          role="tab"
          [class.active]="periodMode === 'week'"
          [attr.aria-selected]="periodMode === 'week'"
          (click)="setPeriodMode('week')"
          [disabled]="loading || exporting || !weeks.length"
        >
          {{ 'WEEKS.WEEK' | translate }}
        </button>
        <button
          type="button"
          class="period-btn"
          role="tab"
          [class.active]="periodMode === 'custom'"
          [attr.aria-selected]="periodMode === 'custom'"
          (click)="setPeriodMode('custom')"
          [disabled]="loading || exporting"
        >
          {{ 'ATTENDANCE_DASH.CUSTOM_RANGE' | translate }}
        </button>
      </div>

      <div class="period-controls">
        <label class="date-picker" *ngIf="periodMode === 'day'">
          <span>{{ 'ATTENDANCE_DASH.DATE' | translate }}</span>
          <input type="date" [(ngModel)]="fromDate" (ngModelChange)="onDayChange()" [disabled]="loading || exporting" />
        </label>

        <app-searchable-select
          *ngIf="periodMode === 'week'"
          class="week-select"
          [(ngModel)]="selectedWeekId"
          [options]="weekOptions"
          [placeholder]="selectWeekLabel"
          [emptyLabel]="selectWeekLabel"
          [searchPlaceholder]="searchPlaceholder"
          [allowEmpty]="false"
          (selectionChange)="onWeekChange()"
        ></app-searchable-select>

        <ng-container *ngIf="periodMode === 'custom'">
          <label class="date-picker">
            <span>{{ 'ATTENDANCE_DASH.FROM' | translate }}</span>
            <input type="date" [(ngModel)]="fromDate" (ngModelChange)="onDateWindowChange()" [disabled]="loading || exporting" />
          </label>
          <label class="date-picker">
            <span>{{ 'ATTENDANCE_DASH.TO' | translate }}</span>
            <input type="date" [(ngModel)]="toDate" (ngModelChange)="onDateWindowChange()" [disabled]="loading || exporting" />
          </label>
        </ng-container>

        <p class="period-summary" *ngIf="periodSummary">{{ periodSummary }}</p>
      </div>
    </div>

    <div class="filter-group class-group">
      <span class="filter-label">{{ 'STUDENTS.CLASS' | translate }}</span>
      <app-searchable-select
        class="class-select"
        [(ngModel)]="selectedClassId"
        [options]="classOptions"
        [placeholder]="allClassesLabel"
        [emptyLabel]="allClassesLabel"
        [searchPlaceholder]="searchPlaceholder"
        [allowEmpty]="true"
        (selectionChange)="onClassChange()"
      ></app-searchable-select>
    </div>
  </section>

  <div class="alert alert-error" *ngIf="errorMessage">{{ errorMessage | translate }}</div>

  <div class="card detail-card" *ngIf="loading && !report && !rangeReport">
    <div class="empty-state">{{ 'COMMON.LOADING' | translate }}</div>
  </div>

  <ng-container *ngIf="!isRangeMode && report">
    <section class="summary-grid">
      <button type="button" class="summary-card" [class.active]="statusFilter === 'all'" (click)="setFilter('all')">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.TOTAL' | translate }}</span>
        <strong>{{ report.summary.total }}</strong>
      </button>
      <button type="button" class="summary-card present" [class.active]="statusFilter === 'present'" (click)="setFilter('present')">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.PRESENT' | translate }}</span>
        <strong>{{ report.summary.present }}</strong>
      </button>
      <button type="button" class="summary-card complete" [class.active]="statusFilter === 'complete'" (click)="setFilter('complete')">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.DAY_COMPLETE' | translate }}</span>
        <strong>{{ report.summary.complete }}</strong>
      </button>
      <button type="button" class="summary-card checked-in" [class.active]="statusFilter === 'checked_in'" (click)="setFilter('checked_in')">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.DAY_CHECKED_IN' | translate }}</span>
        <strong>{{ report.summary.checked_in }}</strong>
      </button>
      <button type="button" class="summary-card absent" [class.active]="statusFilter === 'absent'" (click)="setFilter('absent')">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.DAY_ABSENT' | translate }}</span>
        <strong>{{ report.summary.absent }}</strong>
      </button>
      <button
        type="button"
        class="summary-card late"
        *ngIf="lateEnabled"
        [class.active]="statusFilter === 'check_in_late'"
        (click)="setFilter('check_in_late')"
      >
        <span class="summary-label">{{ 'ATTENDANCE_DASH.LATE_IN' | translate }}</span>
        <strong>{{ report.summary.check_in_late }}</strong>
      </button>
      <div class="summary-card rate present">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.ATTENDANCE_RATE' | translate }}</span>
        <strong>{{ attendanceRate }}%</strong>
      </div>
      <div class="summary-card rate absent">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.ABSENCE_RATE' | translate }}</span>
        <strong>{{ absenceRate }}%</strong>
      </div>
    </section>

    <p class="hint" *ngIf="report.schedule">
      {{
        (lateEnabled ? 'ATTENDANCE_DASH.SCHEDULE_HINT' : 'ATTENDANCE_DASH.SCHEDULE_HINT_NO_LATE')
          | translate: report.schedule
      }}
    </p>

    <div class="card table-card">
      <div class="table-toolbar">
        <div class="table-toolbar-left">
          <input
            type="search"
            class="search-input"
            [(ngModel)]="search"
            [placeholder]="'ATTENDANCE_DASH.SEARCH' | translate"
          />
        </div>
        <div class="table-toolbar-right">
          <span class="muted">{{ filteredRows.length }} / {{ report.summary.total }}</span>
        </div>
      </div>

      <div class="table-scroll">
        <table class="data-table daily-table">
          <thead>
            <tr>
              <th>{{ 'STUDENTS.NAME' | translate }}</th>
              <th class="center-col">{{ 'STUDENTS.CLASS' | translate }}</th>
              <th class="center-col">{{ 'ATTENDANCE_DASH.DAY_STATUS' | translate }}</th>
              <th class="center-col">{{ 'ATTENDANCE.IN' | translate }}</th>
              <th class="center-col">{{ 'ATTENDANCE.OUT' | translate }}</th>
              <th class="actions-col center-col">{{ 'COMMON.ACTIONS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of filteredRows" [class]="'row-' + row.dayStatus" [class.clickable]="permissions.canView('students')" (click)="openStudent(row)">
              <td>
                <strong>{{ studentName(row) }}</strong>
              </td>
              <td class="center-col">{{ row.className || '—' }}</td>
              <td class="center-col">
                <span class="status-badge" [attr.data-status]="row.dayStatus">
                  {{ dayStatusKey(row.dayStatus) | translate }}
                </span>
              </td>
              <td class="center-col">
                <ng-container *ngIf="row.checkIn; else dash">
                  <div>{{ formatTime(row.checkIn.at) }}</div>
                  <span
                    class="timing"
                    *ngIf="lateEnabled"
                    [attr.data-status]="timingStatus(row.checkIn.status)"
                  >
                    {{ timingKey(row.checkIn.status) | translate }}
                  </span>
                </ng-container>
              </td>
              <td class="center-col">
                <ng-container *ngIf="row.checkOut; else dash">
                  <div>{{ formatTime(row.checkOut.at) }}</div>
                  <span
                    class="timing"
                    *ngIf="lateEnabled"
                    [attr.data-status]="timingStatus(row.checkOut.status)"
                  >
                    {{ timingKey(row.checkOut.status) | translate }}
                  </span>
                </ng-container>
              </td>
              <td class="actions-col center-col">
                <button type="button" class="btn btn-secondary btn-sm review-btn" *appAccess="'students:view'" (click)="$event.stopPropagation(); openStudent(row)">
                  <mat-icon>person</mat-icon>
                  {{ 'ATTENDANCE_DASH.OPEN_STUDENT' | translate }}
                </button>
              </td>
            </tr>
            <tr *ngIf="!filteredRows.length">
              <td colspan="6" class="empty-row">{{ 'ATTENDANCE_DASH.EMPTY' | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isRangeMode && rangeReport">
    <section class="summary-grid">
      <div class="summary-card rate">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.TOTAL' | translate }}</span>
        <strong>{{ rangeReport.summary.totalStudents }}</strong>
      </div>
      <div class="summary-card rate">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.DAY_COUNT' | translate }}</span>
        <strong>{{ rangeReport.summary.dayCount }}</strong>
      </div>
      <div class="summary-card rate present">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.ATTENDANCE_RATE' | translate }}</span>
        <strong>{{ rangeReport.summary.attendanceRate }}%</strong>
      </div>
      <div class="summary-card rate absent">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.ABSENCE_RATE' | translate }}</span>
        <strong>{{ rangeReport.summary.absenceRate }}%</strong>
      </div>
      <div class="summary-card rate late" *ngIf="lateEnabled">
        <span class="summary-label">{{ 'ATTENDANCE_DASH.LATE_IN' | translate }}</span>
        <strong>{{ rangeReport.summary.late }}</strong>
      </div>
    </section>

    <p class="hint">
      {{
        (lateEnabled ? 'ATTENDANCE_DASH.RANGE_HINT' : 'ATTENDANCE_DASH.RANGE_HINT_NO_LATE')
          | translate: { from: rangeReport.from, to: rangeReport.to, days: rangeReport.summary.dayCount }
      }}
    </p>

    <div class="card table-card">
      <div class="table-toolbar">
        <div class="table-toolbar-left">
          <input
            type="search"
            class="search-input"
            [(ngModel)]="search"
            [placeholder]="'ATTENDANCE_DASH.SEARCH' | translate"
          />
        </div>
        <div class="table-toolbar-right">
          <span class="muted">{{ filteredRangeRows.length }} / {{ rangeReport.summary.totalStudents }}</span>
        </div>
      </div>

      <div class="table-scroll">
        <table class="data-table range-table">
          <thead>
            <tr>
              <th>{{ 'STUDENTS.NAME' | translate }}</th>
              <th>{{ 'STUDENTS.CLASS' | translate }}</th>
              <ng-container *ngIf="showDayColumns">
                <th *ngFor="let day of rangeReport.days" class="day-col" [class.holiday-col]="isHolidayDay(day)">{{ formatDayShort(day) }}</th>
              </ng-container>
              <th class="metric-col">{{ 'ATTENDANCE_DASH.PRESENT_DAYS' | translate }}</th>
              <th class="metric-col">{{ 'ATTENDANCE_DASH.ABSENT_DAYS' | translate }}</th>
              <th class="metric-col" *ngIf="lateEnabled">{{ 'ATTENDANCE_DASH.LATE_DAYS' | translate }}</th>
              <th class="metric-col">{{ 'ATTENDANCE_DASH.ATTENDANCE_RATE' | translate }}</th>
              <th class="metric-col">{{ 'ATTENDANCE_DASH.ABSENCE_RATE' | translate }}</th>
              <th class="actions-col">{{ 'COMMON.ACTIONS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of filteredRangeRows" [class.clickable]="permissions.canView('students')" (click)="openStudent(row)">
              <td><strong>{{ studentName(row) }}</strong></td>
              <td>{{ row.className || '—' }}</td>
              <ng-container *ngIf="showDayColumns">
                <td
                  *ngFor="let day of rangeReport.days"
                  class="day-col"
                  [class.holiday-col]="isHolidayDay(day) || row.dayMarks[day] === 'holiday'"
                  [attr.data-mark]="dayMarkAttr(row.dayMarks[day], day)"
                >
                  <ng-container *ngIf="!isHolidayDay(day) && row.dayMarks[day] !== 'holiday'">
                    {{ markLetter(row.dayMarks[day]) }}
                  </ng-container>
                </td>
              </ng-container>
              <td class="metric-col">{{ row.presentDays }}</td>
              <td class="metric-col">{{ row.absentDays }}</td>
              <td class="metric-col" *ngIf="lateEnabled">{{ row.lateDays }}</td>
              <td class="metric-col">{{ row.attendanceRate }}%</td>
              <td class="metric-col">{{ rowAbsenceRate(row) }}%</td>
              <td class="actions-col">
                <button type="button" class="btn btn-secondary btn-sm review-btn" *appAccess="'students:view'" (click)="$event.stopPropagation(); openStudent(row)">
                  <mat-icon>person</mat-icon>
                  {{ 'ATTENDANCE_DASH.OPEN_STUDENT' | translate }}
                </button>
              </td>
            </tr>
            <tr *ngIf="!filteredRangeRows.length">
              <td [attr.colspan]="(lateEnabled ? 8 : 7) + (showDayColumns ? rangeReport.days.length : 0)" class="empty-row">
                {{ 'ATTENDANCE_DASH.EMPTY' | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #dash>—</ng-template>
